// @ngInject
function FileDataImportApiService($q, DS, DSHttpAdapter, ResourcesService) {
    return {
        createArticlesOrders: createArticlesOrders,
        getImportFiles: getImportFiles,
        getImportFile: getImportFile,
        updateArticlesOrdersImportFile: updateArticlesOrdersImportFile,
        updateAndFinalizeArticlesOrdersImportFile: updateAndFinalizeArticlesOrdersImportFile,
        deleteArticlesOrdersImportFile: deleteArticlesOrdersImportFile,
        getArticlesOrdersImportColumnMapping: getArticlesOrdersImportColumnMapping,
        setArticlesOrdersImportColumnMapping: setArticlesOrdersImportColumnMapping,
        getSuppliers: getSuppliers,
        getArticleCollections: getArticleCollections,
        getLocations: getLocations,
        getItemGroups: getItemGroups
    };

    function createArticlesOrders(requestDto) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'articlesorders', requestDto).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getImportFiles(page, filter, pageSize) {
        var deferred = $q.defer();
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + 'articlesorders', {params: params}).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getImportFile(importFileId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'articlesorders/' + importFileId).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateArticlesOrdersImportFile(importFileData) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'articlesorders/', importFileData).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateAndFinalizeArticlesOrdersImportFile(importFileData) {
        var deferred = $q.defer();

        console.log("Finalizing with data:");
        console.log(importFileData);

        DSHttpAdapter.PUT(DS.defaults.basePath + 'articlesorders/finalize', importFileData).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deleteArticlesOrdersImportFile(importId) {
        var deferred = $q.defer();

        DSHttpAdapter.DEL(DS.defaults.basePath + 'articlesorders/' + importId).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getArticlesOrdersImportColumnMapping(companyId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'articlesorders/mapping/company/' + companyId).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function setArticlesOrdersImportColumnMapping(companyId, mappingRequest) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'articlesorders/mapping/company/' + companyId, mappingRequest).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getSuppliers() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'articlesorders/suppliers').then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getArticleCollections() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'articlesorders/articlecollections').then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getLocations() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'articlesorders/locations').then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getItemGroups() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'articlesorders/itemgroupbriefs').then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular.module('filedataimport.api', [])
    .factory('FileDataImportApiService', FileDataImportApiService);
